import { IModalDescription, ViewVariant } from '@cp/shared/modal';
import { IDealViewModal } from '../model/types';

export const DEAL_VIEW_MODAL: IModalDescription<IDealViewModal> = {
  nss: 'DEAL_VIEW_MODAL',
  loader: () => import('../ui/dealViewModal').then((module) => module.DealViewModal),
  layout: {
    desktop: ViewVariant.DrawerRight,
    mobile: ViewVariant.DrawerBottom,
  },
};
